import { render, staticRenderFns } from "./PromoAnalyticsDialog.vue?vue&type=template&id=2c512f0e"
import script from "./PromoAnalyticsDialog.vue?vue&type=script&lang=js"
export * from "./PromoAnalyticsDialog.vue?vue&type=script&lang=js"
import style0 from "./PromoAnalyticsDialog.vue?vue&type=style&index=0&id=2c512f0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports